import { render, staticRenderFns } from "./AddToCollectionBtn.vue?vue&type=template&id=8c95bbe8&"
import script from "./AddToCollectionBtn.vue?vue&type=script&lang=js&"
export * from "./AddToCollectionBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddToCollectionBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports